//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TRA_CUSTOM_01 from './M_TRA_CUSTOM_01';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../../../Hooks/back/useBackStack';
//#endregion

export default function M_TRA_CUSTOM_01F(props) {
  //#region 변수
  const { id } = useParams();
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();

  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState([]);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1); // 100% 화면 너비로 시작
  const [pageViewHeight, setPageViewHeight] = useState();
  //#endregion

  // 스택형 뒤로가기로 변경: 교육자료 화면에서는 교육 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/M_TrainingPage', { replace: true }),
  });

  //#region 이벤트
  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1); // 화면 크기 바뀔 때 다시 계산
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dispatch]);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  const Init = async () => {
    setLoading(true);

    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 조회
  // 교육자료 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_M_TRA_CUSTOM_01_R1',
            _DEP_CD: Commons.EncryptAES(id) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].EDU_LOCATION) {
            setInputs({
              ...inputs,
              isNext: true,
            });
          } else {
            setInputs({
              ...inputs,
            });
            const path = data[0].EDU_LOCATION.replace(/\.[^/.]+$/, '.pdf');
            const full = Global.file.useUrl + 'files/' + path;

            setPdfFile(path);
            setFullUrl(full);

            // PDF 이미지 미리보기 생성
            if (getExtensionFromUrl(path) === 'pdf') {
              generatePdfPreview(full);
            }
          }
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const generatePdfPreview = (url) => {
    // URL 직접 전달 - react-pdf가 Range 요청으로 스트리밍 처리
    setRenderPreview(url);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    }
    // else {
    //   navigate('/Home');
    // }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  //#endregion

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        overflow: 'hidden',
        gap: '16px',
      }}
      className="wrap"
    >
      <Stack sx={{ width: '100%', height: '100%' }}>
        <M_TRA_CUSTOM_01
          pdfFile={pdfFile}
          loading={loading}
          setLoading={setLoading}
          onDocumentLoadSuccess={onDocumentLoadSuccess}
          pageNumber={pageNumber}
          pageWidth={pageWidth}
          numPages={numPages}
          renderPreview={renderPreview}
          fullUrl={fullUrl}
          getExtensionFromUrl={getExtensionFromUrl}
          pageViewHeight={pageViewHeight}
          setPageViewHeight={setPageViewHeight}
          // 함수
          goToPrevPage={goToPrevPage}
          goToNextPage={goToNextPage}
        />
      </Stack>
    </Box>
  );
}
